import React from 'react'
import LayoutTitle from 'teleporters/LayoutTitle'
import PageTitle from 'components/common/PageTitle'

export const SettingsPage: React.FC = () => (
  <LayoutTitle.Source>
    <PageTitle>Settings</PageTitle>
  </LayoutTitle.Source>
)

export default SettingsPage
